import { useInfiniteQuery, useQuery } from 'react-query'

import { api } from '../../../api'
import { type FiltersDomain } from '../../../../types/domain/filters-domain'
import { getValidFilters } from '../../../../utils/filters'
import { getQueryStrinfied } from '../../../../utils/query'

export const fetchAdmins = async (filters: FiltersDomain) => {
  const query = getQueryStrinfied(getValidFilters(filters))
  const response = await api.get(`/admins?${query}`)
  return response.data
}

export const useAdminsQuery = (filters: FiltersDomain) => {
  return useQuery(
    ['admins', filters],
    () => fetchAdmins(filters),
    { staleTime: 1000 * 60 * 60 * 1, keepPreviousData: true }
  )
}

export const useInfiniteAdminsQuery = (filters: FiltersDomain) => {
  return useInfiniteQuery(
    ['admins', filters],
    ({ pageParam = 1 }) =>
      fetchAdmins({ ...filters, page: pageParam }),
    {
      staleTime: 1000 * 60 * 60 * 1, // 1 hour
      getNextPageParam ({ meta }) {
        return meta?.hasNextPage ? meta?.page + 1 : undefined
      },
    }
  )
}
